import React from 'react';
import PropTypes from "prop-types";
import decorator from 'lib/lang/decorator';
import {observer} from 'mobx-react';

import {URLBuilder} from 'url-builder/url-builder';

export default decorator(() => Component => {
    function URLBuilderableView(props, context) {
        return (
            <Component
                {...props}
                urlBuilder={context.urlBuilder}
                />
        );
    }

    URLBuilderableView.contextTypes = {
        urlBuilder: PropTypes.instanceOf(URLBuilder),
    };

    return observer(URLBuilderableView);
});
